import {
    TOGGLE_LOADING_INDICATOR,
    SET_MESSAGE_RESPONSE,MessageResponse
} from "./types";

export function toggleLoadingIndicator(showLoading: boolean) {
    return {
        type: TOGGLE_LOADING_INDICATOR,
        payload: showLoading
    };
}

export function setMessageResponse(messageResponse: MessageResponse | null) {
    return {
        type: SET_MESSAGE_RESPONSE,
        payload: messageResponse
    };
}